import { useEffect } from "react";

const useUnityEventBindings = ({
  addEventListener,
  removeEventListener,
  onElementSelected,
  onElementDeselected,
  onEnvironmentChanged,
  onEnvironmentLoadStatesChanged,
  onConditionsChanged,
  onRecordingStarted,
  onUploadAudioFile,
  onReadyToLoadExperience,
  onUserDataApplied,
  onSystemLoaded,
  onSystemFullyLoaded,
  onAssessmentComplete,
  onInstructionVisibilityChanged,
  onInsightStarted,
  onGameStateChanged,
  onGuideStateChanged,
  onGuideAudioLevelChanged,
  onSessionStarted,
}) => {
  useEffect(() => {
    addEventListener("elementSelected", onElementSelected);
    addEventListener("elementDeselected", onElementDeselected);
    addEventListener("environmentChanged", onEnvironmentChanged);
    addEventListener(
      "environmentLoadStatesChanged",
      onEnvironmentLoadStatesChanged,
    );
    addEventListener("conditionChanged", onConditionsChanged);
    addEventListener("conditionsChanged", onConditionsChanged);
    addEventListener("ConditionChanged", onConditionsChanged);
    addEventListener("ConditionsChanged", onConditionsChanged);
    addEventListener("recordingStarted", onRecordingStarted);
    addEventListener("uploadAudioFile", onUploadAudioFile);
    addEventListener("readyToLoadExperience", onReadyToLoadExperience);
    addEventListener("userDataApplied", onUserDataApplied);
    addEventListener("systemLoaded", onSystemLoaded);
    addEventListener("systemFullyLoaded", onSystemFullyLoaded);
    addEventListener("assessmentComplete", onAssessmentComplete);
    addEventListener("instructionVisibilityChanged", onInstructionVisibilityChanged);
    addEventListener("insightStarted", onInsightStarted);
    addEventListener("gameStateChanged", onGameStateChanged);
    addEventListener("guideStateChanged", onGuideStateChanged);
    addEventListener("guideAudioLevelChanged", onGuideAudioLevelChanged);
    addEventListener("guideAudioVolumeChanged", onGuideAudioLevelChanged);
    addEventListener("guideVolumeChanged", onGuideAudioLevelChanged);
    addEventListener("sessionStarted", onSessionStarted);
    addEventListener("SessionStarted", onSessionStarted);

    return () => {
      removeEventListener("elementSelected", onElementSelected);
      removeEventListener("elementDeselected", onElementDeselected);
      removeEventListener("environmentChanged", onEnvironmentChanged);
      removeEventListener(
        "environmentLoadStatesChanged",
        onEnvironmentLoadStatesChanged,
      );
      removeEventListener("conditionChanged", onConditionsChanged);
      removeEventListener("conditionsChanged", onConditionsChanged);
      removeEventListener("ConditionChanged", onConditionsChanged);
      removeEventListener("ConditionsChanged", onConditionsChanged);
      removeEventListener("recordingStarted", onRecordingStarted);
      removeEventListener("uploadAudioFile", onUploadAudioFile);
      removeEventListener("readyToLoadExperience", onReadyToLoadExperience);
      removeEventListener("userDataApplied", onUserDataApplied);
      removeEventListener("systemLoaded", onSystemLoaded);
      removeEventListener("systemFullyLoaded", onSystemFullyLoaded);
      removeEventListener("assessmentComplete", onAssessmentComplete);
      removeEventListener("instructionVisibilityChanged", onInstructionVisibilityChanged);
      removeEventListener("insightStarted", onInsightStarted);
      removeEventListener("gameStateChanged", onGameStateChanged);
      removeEventListener("guideStateChanged", onGuideStateChanged);
      removeEventListener("guideAudioLevelChanged", onGuideAudioLevelChanged);
      removeEventListener("guideAudioVolumeChanged", onGuideAudioLevelChanged);
      removeEventListener("guideVolumeChanged", onGuideAudioLevelChanged);
      removeEventListener("sessionStarted", onSessionStarted);
      removeEventListener("SessionStarted", onSessionStarted);

    };
  }, [
    addEventListener,
    removeEventListener,
    onElementSelected,
    onElementDeselected,
    onEnvironmentChanged,
    onEnvironmentLoadStatesChanged,
    onConditionsChanged,
    onRecordingStarted,
    onUploadAudioFile,
    onReadyToLoadExperience,
    onUserDataApplied,
    onSystemLoaded,
    onSystemFullyLoaded,
    onAssessmentComplete,
    onInstructionVisibilityChanged,
    onInsightStarted,
    onGameStateChanged,
    onGuideStateChanged,
    onGuideAudioLevelChanged,
    onSessionStarted,
  ]);
};

export default useUnityEventBindings;
